// Bespoke invoice layout for McGeoughs Funeral Ltd (cover letter + funeral expenses statement).
export const MCGEOUGHS_EMAIL = 'info@mcgeoughs.ie'

export const DEFAULT_CHARGES_NOTE = 'Our charges include availability of trained staff, use of our facilities as required, coordinating and conducting the funeral, provision of funeral vehicles as per your requirements, attending to administration and legalities, advice and guidance before, during and after the removal and funeral, providing our service as required.'

export function isMcGeoughs(email) {
    return (email || '').trim().toLowerCase() === MCGEOUGHS_EMAIL
}

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

function ordinal(day) {
    if (day >= 11 && day <= 13) return 'th'
    return ({ 1: 'st', 2: 'nd', 3: 'rd' })[day % 10] || 'th'
}

// Returns { day, ordinal, month, year } or null, e.g. { day: 17, ordinal: 'th', month: 'December', year: 2025 }
export function dateParts(value) {
    let d = null
    if (!value) {
        d = new Date()
    } else {
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
        d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value)
    }
    if (isNaN(d.getTime())) return null
    return { day: d.getDate(), ordinal: ordinal(d.getDate()), month: MONTHS[d.getMonth()], year: d.getFullYear() }
}

export function splitAddress(address) {
    return (address || '').split(/[\n,]+/).map(line => line.trim()).filter(line => line.length > 0)
}

export function parentLabel(gender_id) {
    if (gender_id == 1) return 'father'
    if (gender_id == 2) return 'mother'
    return 'loved one'
}
